import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsObject, IsOptional, IsString, Length, ValidateNested } from 'class-validator';
import { OrderConfigExposeGroup } from '../../order-config/interface';
import { PatchPrepTimeCalculationConfigDto } from './PatchPrepTimeCalculationConfigDto';
export class PatchOrderConfigDto {
    constructor() {
        this.preparation = new PatchPrepTimeCalculationConfigDto();
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Order number prefix', example: 'GP' }),
    Length(1, 50),
    IsString({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchOrderConfigDto.prototype, "orderNumberPrefix", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchPrepTimeCalculationConfigDto, description: 'Order preparation time calculation configuration' }),
    Type(() => PatchPrepTimeCalculationConfigDto),
    ValidateNested({ always: true }),
    IsObject({ always: true }),
    IsOptional({ groups: [OrderConfigExposeGroup.PATCH, OrderConfigExposeGroup.CREATE] }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", PatchPrepTimeCalculationConfigDto)
], PatchOrderConfigDto.prototype, "preparation", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object, description: 'Order throttling configuration' }),
    IsObject({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchOrderConfigDto.prototype, "throttling", void 0);
//# sourceMappingURL=PatchOrderConfigDto.js.map